/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import OzFormComponent from './OzFormComponent';
import './MistakeForm.css';

import {
} from '../../actions';


class MistakeForm extends OzFormComponent {

  static fields = [
    'email',
    'body',
  ];

  componentDidMount() {
  }

  renderBody() {
    return (
      <div className="MistakeForm">
        <p>If you spot a mistake on EscapeSpy, please report it. We'll fix it as soon as we can.</p>

        {this.renderFormGroup('What is the mistake?', 'textarea', 'body', { helptext: 'Describe what you saw, and why it was wrong' })}
        {this.renderFormGroup('Want us to follow up with you? (optional)', 'text', 'email', { helptext: "If you leave your email address, we'll follow up once we fix the mistake", placeholder: 'email@example.com' })}

        <p>Thanks for helping improve to EscapeSpy.</p>

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    upload: (...args) => dispatch(upload(...args)),
    getSuggestions: (...args) => dispatch(getSuggestions(...args)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MistakeForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/MistakeForm.js
 **/